import { writable, type Writable } from 'svelte/store';
import { browser } from '$app/environment';

export const writableSessionStorage = <T>(key: string, initialValue: T): Writable<T> => {
	let store: Writable<T>;

	if (browser) {
		// We're on the client side, safe to use sessionStorage
		const sessionValue = sessionStorage.getItem(key);
		const value = sessionValue ? JSON.parse(sessionValue) : initialValue;
		store = writable(value);

		store.subscribe((val) => {
			sessionStorage.setItem(key, JSON.stringify(val));
		});
	} else {
		// We're on the server or in an environment where sessionStorage is not available
		store = writable(initialValue);
	}

	return store;
};
